import ArrowDownThin from '@ori-ui/icons/lib/ArrowDownThin';
const MuiSelect = {
  IconComponent: ArrowDownThin,
  variant: 'outlined',
  MenuProps: {
    elevation: 0,
    classes: {
      paper: 'OriSelectPaper',
      list: 'OriSelectList'
    }
  }
};
export default MuiSelect;